"use strict";

angular.module('app.models.favorite', []).//

factory('__Favorite', ['restmod', 'appConfig', '__Datapoint', 'f_User', '$filter','__Scene','__Device','__MenuEntry', 'f_Favorites', function(restmod, appConfig, __Datapoint, f_User, $filter, __Scene, __Device, __MenuEntry, f_Favorites) {


    //noinspection JSDuplicatedDeclaration
    return restmod.model('/Favorite').mix('BaseModel').mix({
        //$pk:'DeviceId',
        prepareFavorite: function () {
            if (!this.$UI) {
                this.$UI = {};
            }

            if (this.UserLevelWrite <= f_User.getUserLevel()) {
                this.$UI.canWrite = true;
            }

            this.prepareFavoriteByType();
            this.resolvePermissions();
        },
        resolvePermissions: function () {
            var b, a;
            var UserLevel = f_User.getUserLevel();

            if (this.UserLevelRead >= UserLevel) {
                // normaly API will filter non readable
                a = true;
            } else {
                a = false;
            }
            this.canView = a;

            if (
                (this.UserLevelWrite > UserLevel // We can't write it
                )
            ) {
                b = false;
            } else {
                b = true;
            }
            this.canWrite = b;

        },
        updateFavoriteData:function(data){

            switch(this.$UI.FavoriteType){

                case "Scene":
                    // Update Enabled, AllActionsRunning
                    this.Enabled = data.Enabled;
                    //this.$UI.Scene.Enabled = data.Enabled;
                    this.ActionIsRunning = data.ActionIsRunning;
                    this.ConditionIsTrue = data.ConditionIsTrue;
                    break;
                case "CustomAction":
                    //this.$UI.Scene.Enabled = data.Enabled;

                    break;
                case "MenuEntry":
                   // this.$UI.Scene.Enabled = data.Enabled;

                    this.$UI.MenuEntry = data.$UI.MenuEntry;
                    this.$UI.MenuEntry.$UI.buildAllDatapoints = false;
                   // this.$UI.MenuEntry.$dispatch('build-datapoints');;//.$dispatch('');
                    break;
                case "Device":

                    this.$UI.Device = data.$UI.Device;


                    this.$UI.Device.IsOffline = data.IsOffline;
                    this.$UI.Device.IsDisabled = data.IsDisabled;
                    this.$UI.Device.DeviceType = data.DeviceType;



                    break;
                case "Datapoint":
                    var o = this;
                    this.DatapointValue = data.DatapointValue;
                    this.DatapointConfig = data.DatapointConfig;
                    this.Datapoint = __Datapoint.$buildRaw(
                        {
                            'DatapointConfig': o.DatapointConfig,
                            'DatapointValue': o.DatapointValue
                        }
                    );
                    this.Datapoint.$dispatch('build');

                    break;
            }
            this.IsOffline = data.IsOffline;
            this.IsDisabled = data.IsDisabled;
            this.Position = data.Position;
            this.DisplayName = data.DisplayName;
            this.ShowOnStartScreen = data.ShowOnStartScreen;

        },
        prepareFavoriteByType: function () {
            var o = this;
            // if(o.$type != undefined && typeof o.$type == 'string'){o._type = o.$type;};
            if (o._type) {
                switch (o._type) {
                    case "BMS.Shared.Model.System.FavoriteCustomAction, BMS.Shared":
                        this.$UI.FavoriteType = 'CustomAction';
                        break;
                    case "BMS.Shared.Model.System.FavoriteMenuEntry, BMS.Shared":
                        var me;
                        if (o.CustomActionName !== undefined) {
                            me = 'CustomAction';
                        } else {
                            me = 'MenuEntry';
                        }
                        this.$UI.FavoriteType = me;
                        var vdp = this.VisualizationDatapoints && this.VisualizationDatapoints._values ? this.VisualizationDatapoints._values : [];

                        this.$UI.MenuEntry = __MenuEntry.$buildRaw({
                            MenuEntryId:this.MenuEntryId,
                            MenuEntryType:this.MenuEntryType,
                            DeviceId : this.DeviceId,
                            VisualizationDatapoints:vdp
                        }).$dispatch('build-datapoints');
                        break;
                    case "BMS.Shared.Model.System.FavoriteScene, BMS.Shared":
                        this.$UI.FavoriteType = 'Scene';
                        this.$UI.Scene = __Scene.$buildRaw({
                            SceneId:this.SceneId,
                            Enabled: this.Enabled
                        });
                        break;
                    case "BMS.Shared.Model.System.FavoriteDevice, BMS.Shared":
                        this.$UI.FavoriteType = 'Device';
                        var vdp = this.VisualizationDatapoints && this.VisualizationDatapoints._values ? this.VisualizationDatapoints._values : [];
                        this.$UI.Device = __Device.$buildRaw({
                            DeviceId : this.DeviceId,
                            DeviceType : this.DeviceType,
                            IsOffline : this.IsOffline,
                            IsDisabled: this.IsDisabled,
                            VisualizationDatapoints: vdp
                        }).$dispatch('build-view-datapoints');
                        break;
                    case  "BMS.Shared.Model.System.FavoriteDatapoint, BMS.Shared":
                        this.$UI.FavoriteType = "Datapoint";
                        // Extend the Value object by Datapoint Config ID,DeviceId and correct Type. So we can refresh Datapoints;
                        if (o.DatapointConfig !== undefined) {
                            this.Datapoint = __Datapoint.$buildRaw(
                                {
                                    'DatapointConfig': o.DatapointConfig,
                                    'DatapointValue': o.DatapointValue
                                }
                            );
                            this.Datapoint.$dispatch('build');
                        }

                        break;
                }
            } else {
                if (o.DeviceId !== undefined && o.MenuEntryId === undefined && o.DatapointConfig === undefined) {
                    this.$UI.FavoriteType = 'Device';
                }
                if (o.DeviceId !== undefined && o.MenuEntryId !== undefined && o.DatapointConfig === undefined) {
                    this.$UI.FavoriteType = 'MenuEntry';
                }
                if (o.SceneId !== undefined) {
                    this.$UI.FavoriteType = 'Scene';
                }
                if (o.DatapointConfigId !== undefined) {
                    this.$UI.FavoriteType = 'Datapoint';
                }
                if (o.DatapointConfig !== undefined) {
                    this.$UI.FavoriteType = 'Datapoint';
                }

            }

        },
        decodeUITags: function () {
            var o = this;
            o.$UI.UITags = {};
            if (o.UITags && o.UITags._values) {
                var tags = o.UITags._values;
                for (var i = 0; i < tags.length; ++i) {
                    var slicer = tags[i].indexOf(':');
                    if (slicer > 0) {
                        o.$UI.UITags[tags[i].slice(0, slicer)] = this.deserializeUIObject('[' + tags[i].slice(slicer + 1) + ']');
                    }
                }
            }
        },
        encodeUITags: function () {
            if (!this.UITags) {
                return;
            }
            var UITags = this.$UI.UITags;
            this.UITags.$values = [];
            for (var UITag in UITags) {
                var tag = UITags[UITag];
                UITag += ':';
                if (!tag) {
                    return;
                }
                for (var i = 0; i < tag.length; ++i) {
                    UITag += tag[i];
                    if (i < tag.length - 1) {
                        UITag += '|';
                    }
                }
                this.UITags.$values.push(UITag);
            }
        },
        $pk: 'FavoriteId',
        _type: {map: '$type'},
        'UITags._type': {map: '$type'},
        'VisualizationDatapoints._values': {map: '$values'},
        'UITags._values': {map: '$values'},
        'CustomActionDatas._type': {map: '$type'},
        'CustomActionDatas._values': {map: '$values'},
        $config: {name: 'ResponseData', plural: 'ResponseData'},
        Datapoint: {'hasOne': '__Datapoint'},

        $hooks: {
            'prepareFavorite': function(){
                this.prepareFavoriteByType();
            },
            'after-request': function (_req) {

            },
            'after-feed-many': function () {

            },
            'after-feed': function (req) {
                this.$UI = !this.$UI ? {} : this.$UI;
                this.prepareFavorite();
                this.decodeUITags();
            },
            'after-save':function(){
                this.$UI.loading=false;
            },
            'before-save':function(){
                this.$UI.loading=true;

                if( !this.FavoriteId ){
                    this.UserLevelWrite = 0;
                    this.UserLevelRead = 0;
                }

            },
            'before-destroy': function (_req) {
                _req.url = appConfig().api_host + 'Favorite/RemoveFavorite';
                _req.method = 'POST';

            },
            'refresh': function (p) {
                var t = this;
                this.$getAll().$then(function (data) {
                    t = data;
                    t.$dispatch('refresh-values');
                });
            }
        },
        $destroy: function (_params) {
            return this.$decorate({
                'before-request': function (_req) {
                    _req.url = appConfig().api_host + 'Favorite/RemoveFavorite';
                    _req.method = 'POST';
                    _req.data = {FavoriteId: this.FavoriteId};
                    //alert()
                },
                'after-request' :function(){

                }
            }, function () {
                // every method from same context called inside this function will be decorated.
                return this.$fetch();
            }).$then(function () {
                f_Favorites.removeFavorite(this);
            });
        },
        $extend: {

            Record: {
                hooks: {
                    'before-destroy': function (_req) {

                        _req.url = appConfig().api_host + 'Favorite/RemoveFavorite';
                    }
                },
                $refresh : function () {
                    return this.$decorate({
                        'before-request': function (_req) {
                            _req.method = 'POST';
                            _req.data = {'FavoriteId': this.FavoriteId, 'WithDetails': true};
                            _req.params = null;
                            _req.url = appConfig().api_host + 'Favorite/GetFavoriteById';
                        },
                        'after-request': function (_req) {
                            _req.data = _req.data ;

                        }
                    }, function () {
                        return this.$fetch();
                    }).$then(function () {
                        f_Favorites.addFavorite(this);
                    });
                },
                $save: function (_token) {
                    this.encodeUITags();
                    return this.$decorate({
                        'before-request': function (_req) {
                            /* Transform $save Calls */
                            _req.url = appConfig().api_host + 'Favorite/AddOrUpdateFavorite';
                            _req.method = 'POST';
                            var data = this.$encode();
                            var o = {$type: data._type};
                            delete data.editmode;
                            delete data.canWrite;
                            delete data.canView;
                            delete data.DatapointConfig;
                            delete data.DatapointValue;
                            delete data.VisualizationDatapoints;
                            var u = data;
                            delete u._type;
                           //alert('Saving '+data.FavoriteId+' //////// '+this.FavoriteId);
                            if(data.UITags == null){
                                delete data.UITags;
                            }

                            /* If there is no FavoriteId, the favorite has to be a new one.
                               Current user *Write/*Read levels are not used anymore. */
                            if(!data.FavoriteId)
                            {
                                u.UserLevelWrite = 0;
                                u.UserLevelRead = 0;
                            }

                            _req.data = {'Favorite': angular.extend(o, u)};

                        },
                        'after-request' : function(_req){
                            if (!this.FavoriteId) {

                               var fid = _req.data;
                                this.FavoriteId = _req.data;
                                //this.FavoriteId;
                                _req.data = this.$encode();
                              //  console.log(_req.data);
                                _req.data.FavoriteId = fid;
                              //  console.log(this);
                             }else{
                                _req.data = this.$encode();
                            }

                        }
                    }, function () {
                        return this.$fetch();
                    }).$then(function () {
                        f_Favorites.addFavorite(this);
                    });
                },
                getUITag: function (UITag) {
                    return this.$UI.UITags[UITag];
                },
                hasUITagId: function (UITag, id) {
                    if (!this.$UI.UITags[UITag]) {
                        return false;
                    }

                    return this.$UI.UITags[UITag].indexOf(id) !== -1;
                },
                setUITagId: function (UITag, id) {
                    if (!this.$UI.UITags[UITag]) {
                        this.$UI.UITags[UITag] = [];
                    }

                    this.$UI.UITags[UITag].push(id);
                }
            },
            Scope: {
                $byId: function (params) {
                    return this.$collection(false).$decorate({
                        'before-request': function (_req) {
                            _req.method = 'POST';
                            _req.data = {'FavoriteId': params};
                            _req.params = null;
                            _req.url = appConfig().api_host + 'Favorite/GetFavoriteById';
                        },
                        'after-request': function (_req) {
                            _req.data = [_req.data];

                        }
                    }, function () {
                        return this.$find();
                    }).$then(function () {
                        f_Favorites.addFavorite(this);
                    });
                },
                $getAll: function (params) {
                    return this.$collection(params).$decorate({
                        'before-request': function (_req) {
                            _req.method = 'POST';
                            _req.params = null;
                            if(!params){ params = {};};
                            _req.data = params;
                            _req.url = appConfig().api_host + 'Favorite/GetFavorites';
                        }
                    }, function () {
                        return this.$fetch();
                    }).$then(function () {

                        f_Favorites.setFavorites(this)
                    });
                }
            },
            List: {
                $filter: function (_what) {
                    var ordered = $filter('filter')(this, _what);
                    // reset the collection contents:
                    this.length = 0;
                    this.push.apply(this, ordered);
                    return this;
                },
                $orderBy: function (_what) {
                    var ordered = $filter('orderBy')(this, _what);
                    // reset the collection contents:
                    this.length = 0;
                    this.push.apply(this, ordered);
                    return this;
                },
                $getByUIID: function (UIID) {
                    for (var i = 0; i < this.length; ++i) {
                        if (this[i].$UI.UITags && this[i].$UI.UITags.UIID && this[i].$UI.UITags.UIID[0] === UIID) {
                            return this[i];
                        }
                    }
                    return undefined;
                }
            }
        }
    });
}]);
